import projects from "../data/projects.json"

<intro-section />
<about-section />
<project-carousel projects=projects />
<contact-section />
